import React, { Component } from 'react'
import {CalendarStats} from "./CalendarStats";
import styled from "styled-components";
import CheckLoginStatus from "../../conditions/CheckLoginStatus";
import WithPatient from "../../conditions/WithPatient";
import {AdherenceChart} from "./AdherenceChart";
import {WeeklySummary} from "./WeeklySummary";
import DashboardLayout from "../../layouts/DashboardLayout";

export const AdherenceContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;  // 1 column on small screens
  grid-gap: 20px;
  padding: 20px;

  @media (min-width: 768px) {
    // 2 columns on medium and larger screens
    grid-template-columns: 1fr 1fr; // Each component takes half of the space
    grid-template-areas:
      "calendar chart"
      "summary summary"; // WeeklySummary spans both columns
  }
  
  @media (max-width: 767px) {
    // Stack everything in a single column on small screens
    grid-template-areas:
      "calendar"
      "chart"
      "summary";
  }
`

export const CalendarContainer = styled.div`
  grid-area: calendar;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  box-sizing: border-box;
  
  @media (max-width: 900px) {
    max-width: 100%;
    height: 600px;
  }

  @media (max-width: 600px) {
    max-width: 100%;
    height: 500px;
  }

  @media (max-width: 400px) {
    max-width: 100%;
    height: 400px;
  }
`

export const ChartContainer = styled.div`
  grid-area: chart;
  // Styles for the adherence chart container
`

export const SummaryContainer = styled.div`
  grid-area: summary;
  // Additional styles if needed
`

export class AdherenceStats extends Component {
  render() {
    const { match } = this.props
    const { patientID } = match.params
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <DashboardLayout title="Adherence Stats" noPad
                         backHref="/adherence-dashboard" backText="Adherence Dashboard">
          <WithPatient patientID={patientID}>
            <AdherenceContainer>
              <CalendarContainer>
                <CalendarStats/>
              </CalendarContainer>
              <ChartContainer>
                <AdherenceChart />
              </ChartContainer>
              <SummaryContainer>
                <WeeklySummary />
              </SummaryContainer>
            </AdherenceContainer>
          </WithPatient>
        </DashboardLayout>
      </CheckLoginStatus>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/AdherenceStats/index.js